import React, { useState } from "react";
import { Button, Tab } from "semantic-ui-react";
import { BasicModal } from "../../../components/Shared";
import { ListSyllabu, SyllabuForm } from "../../../components/Admin/Syllabu";
import { usePermissions } from "../../../hooks";
import "./Syllabu.scss";

export function Syllabu() {
  const { hasPermission } = usePermissions();
  const [showModal, setShowModal] = useState(false);
  const [reload, setReload] = useState(false);

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onReload = () => setReload((prevState) => !prevState);

  const canCreate = hasPermission("syllabu", "create");

  const panes = [
    {
      render: () => (
        <Tab.Pane attached={false}>
          <ListSyllabu reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <>
      <div className="syllabu-page">
        {canCreate && (
          <Button className="syllabu-page__add" primary onClick={onOpenCloseModal}>
            Nueva malla curricular
          </Button>
        )}
        <Tab menu={{ secondary: true }} panes={panes} />
      </div>
      <BasicModal show={showModal} close={onOpenCloseModal} title="Crear malla curricular">
        <SyllabuForm onClose={onOpenCloseModal} onReload={onReload} />
      </BasicModal>
    </>
  );
}
